import React from 'react';
import css from './TalentPlusServices.module.css';
const PriceInput = ({ type, fieldIndex, fields, service, initialPrice }) => {
  return (
    <div className={css.customFldSec}>
      <span className={css.currency}>$</span>
      <input
        type="number"
        className={css.input}
        placeholder={`Enter hourly price for ${type}`}
        value={fields.value[fieldIndex]?.price || initialPrice || ''}
        onChange={e => {
          const newPrice = e.target.value;

          if (fieldIndex !== -1) {
            fields.update(fieldIndex, {
              ...fields.value[fieldIndex],
              price: newPrice,
            });
          }
        }}
      />
      <span className={css.price}>.00</span>
    </div>
  );
};

export default PriceInput;
